<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
  </div>
</template>
  
<script>
export default {
  name: 'Layout',
  computed: {
    key() {
      return this.$route.path
    }
  }
}

</script>

<style>
</style>
  